import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import emojiFlags from '../../../../utilities/isoUnicode';
import { getCountryName } from '../../../../utilities/countryHelpers';

const emojiStyle = { display: 'inline-block', width: '18px' };
const emojiContainerStyle = { display: 'flex', alignItems: 'center' };

class CountryDisplay extends PureComponent {
  static propTypes = {
    countryCode: PropTypes.string.isRequired
  };

  render() {
    const { countryCode } = this.props;

    return (
      <div style={emojiContainerStyle} key={countryCode}>
        <span style={emojiStyle} dangerouslySetInnerHTML={{ __html: emojiFlags[countryCode] }} />&nbsp;
        <span>{getCountryName(countryCode)}</span>
      </div>
    );
  }
}

export default CountryDisplay;
